/** @jsxImportSource @emotion/react */
import { RefObject, memo, PropsWithChildren } from 'react';

import useClickOutside from '../../hooks/useClickOutside';
import * as styles from './Popup.style';

export type AlignType = 'left' | 'right';

export type PopupProps = PropsWithChildren<{
  className?: string;
  visible: boolean;
  insideElements?: RefObject<HTMLElement>[]; // 클릭해도 outside로 인식되지 않는 dom
  onOutsideClick?: (event?: Event) => void;
  top?: number;
  align?: AlignType;
}>;

function Popup({
  className,
  visible,
  onOutsideClick,
  insideElements = [],
  top = 0,
  align = 'left',
  children,
}: PopupProps) {
  const { ref } = useClickOutside(visible, insideElements, onOutsideClick);

  return (
    <div
      ref={ref}
      className={className}
      css={visible ? styles.wrapper(top, align) : [styles.wrapper(top, align), styles.invisible]}
    >
      {children}
    </div>
  );
}

export default memo(Popup);
